import React, { useMemo, useState } from 'react';
import { Box, Button, Typography, Stack, Divider, InputAdornment, IconButton } from '@mui/material';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import EditIcon from '@mui/icons-material/Edit';
import { SimpleTreeView, TreeItem } from '@mui/x-tree-view';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import { InputUI } from '../Interface';

const ItemCategoryTree = ({ setSelectedValues, onAddClick, operatorsDisabled, treeData, viewField, onModClick }) => {
  const [searchText, setSearchText] = useState('');

  const filterTree = (nodes) => {
    if (!searchText.trim()) return nodes;

    const search = searchText.toLowerCase().trim();

    return nodes
      .map((node) => {
        const filteredChildren = filterTree(node.children || []);
        const isMatch = node.name?.toLowerCase().includes(search);

        if (isMatch || filteredChildren.length > 0) {
          return {
            ...node,
            children: filteredChildren,
          };
        }

        return null;
      })
      .filter(Boolean);
  };

  const filteredTreeData = useMemo(() => {
    return filterTree(treeData);
  }, [treeData, searchText]);

  const renderTree = (node) => (
    <TreeItem
      key={node.id}
      itemId={String(node.id)}
      label={
        <Stack direction="row" spacing={1} alignItems="center">
          <FolderOutlinedIcon fontSize="small" color="primary" />
          <Typography variant="body2">{node.name}</Typography>
        </Stack>
      }
      onClick={() => {
        if (!viewField) return;

        setSelectedValues(node);
      }}
    >
      {node.children?.map((child) => renderTree(child))}
    </TreeItem>
  );

  return (
    <>
      <Stack justifyContent="space-between" direction="row" alignItems="center" mb={2}>
        <Typography fontWeight="bold" sx={{ fontSize: 18 }}>
          Termékkategóriák
        </Typography>
        <Stack direction="row" spacing={2}>
          <Button
            variant="outlined"
            startIcon={<EditIcon />}
            sx={{ fontWeight: 'bold' }}
            onClick={onModClick}
            disabled={!viewField || operatorsDisabled}
          >
            Szerkesztés
          </Button>
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            sx={{ fontWeight: 'bold' }}
            onClick={onAddClick}
            disabled={!viewField}
          >
            Új kategória
          </Button>
        </Stack>
      </Stack>
      <Box width="300px">
        <InputUI
          placeholder="Keresés..."
          size="small"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <Divider sx={{ my: 2 }} />
      <Box>
        <SimpleTreeView>{filteredTreeData.map((node) => renderTree(node))}</SimpleTreeView>
      </Box>
    </>
  );
};

export default ItemCategoryTree;
